const PAGES_ROOT_PATH = 'bui/';
const STORAGE_KEY_PREFIX = 'lvflanders.bar.ng.core.';

export const BAR_CORE_CONSTANTS = {
    STORAGE_KEY_PREFIX,
    PAGES: {
        ONBESCHIKBAAR: PAGES_ROOT_PATH + 'blokkerende-melding',
        SESSION_EXPIRED: PAGES_ROOT_PATH + 'session-expired',
        INSUFFICIENT_PRIVILEGES: PAGES_ROOT_PATH + 'insufficient-privileges',
        LOG_OFF: PAGES_ROOT_PATH + 'log-off'
    }
} as const;
